/* ==========================================================================
   HYBEC AIR — quick-view popup
   Delegated click listener on the document, so it works for
   [data-hy-quickview-trigger] buttons anywhere on the page (current cards
   or any rendered later) without re-wiring. Fetches the Shopify storefront
   product JSON endpoint — same pattern already used by the wishlist
   feature — so no extra section/product data needs to be piped into the
   page up front.
   ========================================================================== */
(function () {
  'use strict';

  var modal, closers, img, tag, title, price, desc, link;
  var lastFocused = null;
  var cache = {};

  function els() {
    if (modal) return;
    modal = document.querySelector('[data-hy-quickview]');
    if (!modal) return;
    closers = modal.querySelectorAll('[data-hy-quickview-close]');
    img = modal.querySelector('[data-hy-quickview-image]');
    tag = modal.querySelector('[data-hy-quickview-tag]');
    title = modal.querySelector('[data-hy-quickview-title]');
    price = modal.querySelector('[data-hy-quickview-price]');
    desc = modal.querySelector('[data-hy-quickview-desc]');
    link = modal.querySelector('[data-hy-quickview-link]');

    closers.forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  function formatMoney(cents, currency) {
    var amount = (cents / 100).toFixed(2);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR',
        minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return amount;
    }
  }

  function stripHtml(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    return (d.textContent || d.innerText || '').trim();
  }

  function splitOverview(text) {
    var normalized = (text || '')
      .replace(/\s+/g, ' ')
      .replace(/\bBLDC\s+power\s+saver\b/gi, 'BLDC Power Saver')
      .trim();

    if (!normalized) return [];

    var patterns = [
      /\bNoise\s+Free\b/i,
      /\b\d+\s+Abs\s+Blades\b/i,
      /\bAnti\s+Dust\b/i,
      /\bUp\s+To\s+\d+\s+Hours?\s+Timer\s+Setting\b/i,
      /\b\d+%\s+Pure\s+Copper\s+Wire\s+Motor\b/i,
      /\bDouble\s+Ball\s+Bearing\b/i,
      /\bReverse\s+Rotation\b/i,
      /\bBLDC\s+Power\s+Saver\b/i,
      /\bSweep\s+\d+(?:\.\d+)?\s*(?:"|\u201d|''|inch|in|mm)?/i,
      /\b\d+\s*pp\s+Blades\b/i,
      /\bThermal\s+Overload\s+Protector\b/i,
      /\bSuitable\s+For\s+Recessed\s+Ceiling\b/i,
      /\bParametrical\s+Air\s+Extraction\b/i,
      /\bHigh\s+Air\s+Suction\b/i,
      /\bAir\s+Delivery\s*\([^)]*\)\s*\d+\b/i,
      /\bRPM\s+\d+\b/i,
      /\bMotor\s+Power\s*\([^)]*\)\s*\d+\b/i,
      /\bWarranty\s+\d+\s+Years?\b/i
    ];

    var matches = [];
    patterns.forEach(function (pattern) {
      var match = normalized.match(pattern);
      if (match && match.index > -1) {
        matches.push({
          index: match.index,
          text: match[0].replace(/\s+/g, ' ').trim()
        });
      }
    });

    matches.sort(function (a, b) {
      return a.index - b.index;
    });

    var seen = {};
    matches = matches.filter(function (item) {
      var key = item.text.toLowerCase();
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });

    if (matches.length >= 4) return matches.map(function (item) { return item.text; });

    return normalized
      .split(/(?:\s*[•|,]\s*|\.\s+)/)
      .map(function (item) { return item.trim(); })
      .filter(Boolean)
      .slice(0, 8);
  }

  function renderOverview(text) {
    var items = splitOverview(text);
    desc.innerHTML = '';

    if (items.length > 1) {
      var list = document.createElement('ul');
      list.className = 'hy-quickview__specs';
      items.slice(0, 8).forEach(function (item) {
        var li = document.createElement('li');
        li.textContent = item;
        list.appendChild(li);
      });
      desc.appendChild(list);
      return;
    }

    var paragraph = document.createElement('p');
    paragraph.textContent = text;
    desc.appendChild(paragraph);
  }

  function open(handle) {
    els();
    if (!modal) return;

    function render(data) {
      img.src = (data.featured_image || (data.images && data.images[0]) || '').replace(/\.(jpg|jpeg|png|webp)/, '_800x$&');
      img.alt = data.title;
      tag.textContent = (data.type || data.vendor || '').toUpperCase();
      title.textContent = data.title.replace(/ Series$/i, '');
      var min = data.price_min != null ? data.price_min : data.price;
      var max = data.price_max != null ? data.price_max : data.price;
      price.textContent = min === max ? formatMoney(min) : formatMoney(min) + ' – ' + formatMoney(max);
      var plain = stripHtml(data.description);
      renderOverview(plain);
      link.href = data.url;

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      lastFocused = document.activeElement;
      modal.querySelector('.hy-quickview__close').focus();
    }

    if (cache[handle]) {
      render(cache[handle]);
      return;
    }

    fetch('/products/' + handle + '.js')
      .then(function (r) {
        return r.ok ? r.json() : Promise.reject(r.status);
      })
      .then(function (data) {
        cache[handle] = data;
        render(data);
      })
      .catch(function () {
        /* Quietly no-op — worst case the shopper just uses the product link on the card. */
      });
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-hy-quickview-trigger]');
    if (!trigger) return;
    e.preventDefault();
    open(trigger.getAttribute('data-hy-quickview-trigger'));
  });
})();
